import { Toast } from '../../models/toast'

const apply = (
    state: any,
    type: string,
    error: { response: { data: { message: string } }; message: string },
    toastList: Toast[] = []
) => {
    const matches = /(.*)_(REQUEST|FAILURE)/.exec(type)

    // not a *_REQUEST / *_FAILURE actions, so we ignore them
    if (!matches) return state

    const [, requestName, requestState] = matches

    let _error = undefined

    if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
    ) {
        _error = error.response.data.message
    }

    if (!_error) {
        _error = error
            ? error.message
                ? error.message
                : 'commons.error.generic'
            : undefined
    }

    const value = requestState === 'FAILURE' && _error
    const existingToastList = state.toastList || []
    toastList = toastList.map((toast) => ({
        ...toast,
        id: Math.random() * 100,
    }))
    const newToastList = [...existingToastList, ...toastList]

    return {
        ...state,
        // Store errorMessage
        // e.g. stores errorMessage when receiving GET_TODOS_FAILURE
        //      else clear errorMessage when receiving GET_TODOS_REQUEST
        [requestName]: value,
        __LAST: value,
        toastList: newToastList,
    }
}

export default (state = {toastList: []}, action) => {
    const { type, error, toastList } = action
    switch (type) {
        case '__ALL_ERROR__':
            return {}
        case '__TIMEOUT_ERROR__':
            return {
                ...state,
                __TIMEOUT: true,
            }
        case 'CLEAR_TOAST':
            const newToastList = [...state.toastList].filter(
                (toast) => action.toastIds.indexOf(toast.id) < 0
            )
            return {
                ...state,
                toastList: newToastList,
            }
        default: {
            if (Array.isArray(type)) {
                const nextState = type.reduce((nState, t) => {
                    return apply(nState, t, error, toastList)
                }, state)
                return nextState
            } else {
                return apply(state, type, error, toastList)
            }
        }
    }
}
